import { FC, useEffect, useState } from "react";
import { useAppContext } from "../../../../../system/providers/appContextProvider";
import { KizMarkDataProvider } from "../../../../../Services/DataProviders/KizMarkDataProvider";
import { IKizMarkViewDTO } from "../../../../../libs/coreapi-dto/service/kizMark";
import { LoadingStatus } from "../../../../../@types/enumsGlobal";
import useGridFilter, { DefaultGridFilter } from "../../../../../system/hooks/useGridFilter";
import { PluginWrapper } from "../../../../../components/plugins";
import { DefaultGrid } from "../../../../../components/grids/default/defaultGrid";
import styles from '../../../../styles/index.module.scss'
import { usePluginContext } from "../../../../../system/providers/plugin";

const ChequeKizMarkGrid: FC<IGridProps> = (props) => {
    const appCtx = useAppContext();
    const kizMarkDataProvider = new KizMarkDataProvider(appCtx.coreApiService);

    const [data, setData] = useState<IKizMarkViewDTO[]>([]);
    const [loadingStatus, setLoadingStatus] = useState<LoadingStatus>(LoadingStatus.InProcess);
    const [totalCount, setTotalCount] = useState(0);
    const [gridFilter, dispatchGridFilter] = useGridFilter(DefaultGridFilter);
    const [selectedItem, setSelectedItem] = useState<IGridRow>();
    const pluginCtx = usePluginContext();

    useEffect(() => {
        dispatchGridFilter({
            type: 'addColumnFilter',
            payload: {
                name: "docNum",
                value: pluginCtx.masterGrid.selectedItem?.cells?.find(element => element.propertyName === 'mnemocode')?.value,
                operator: "Eq"
            },
        });
    }, [pluginCtx.masterGrid.selectedItem?.idGlobal])
    
    useEffect(() => {
        setLoadingStatus(LoadingStatus.InProcess);
        kizMarkDataProvider.getView(gridFilter, (entities, totalCount) => {
            try {
                setData(entities);
                setTotalCount(totalCount);
                setLoadingStatus(LoadingStatus.Completed);
            } catch {
                setLoadingStatus(LoadingStatus.Failed);
            }
        })
    }, [gridFilter])

    return (
        <PluginWrapper>
            <div className={styles.gridWrapper}>
                <div className={styles.masterGrid}>
                    <DefaultGrid
                        gridId={props.gridId}
                        data={data}
                        loadingStatus={loadingStatus}
                        setLoadingStatus={setLoadingStatus}
                        totalCount={totalCount}
                        dataProvider={kizMarkDataProvider}
                        filter={gridFilter}
                        separator
                        plugin={props.plugin}
                        selectedItem={selectedItem}
                        onSelect={(row) => {
                            setSelectedItem(row)
                            props?.onSelect?.(row)
                        }}
                        onDoubleClick={(i) => props.onDoubleClick?.(i)}
                        onSort={(i) => dispatchGridFilter({ type: "sort", payload: i.propertyName })}
                        onFilterDelete={(i) => dispatchGridFilter({ type: "deleteColumnFilter", payload: i.propertyName })}
                        onPageNumberChange={(n) => dispatchGridFilter({ type: "changePageNumber", payload: { pageNumber: n } })}
                        onNumberPerPageChange={(n) => dispatchGridFilter({ type: "changeNumberPerPage", payload: { numberPerPage: n } })}
                        hiddenPagination={{ hiddenCountRow: true, hiddenNumberPage: true }}
                    />
                </div>
            </div>
        </PluginWrapper>
    )
}

export default ChequeKizMarkGrid